// 1111 => 1,111
export const formatToThousandSeparator = (numberString: string) => {
  return numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatTruckingRate = (numberString: string) => {
  const numberWithDecimals = Number(numberString).toFixed(2);
  return formatToThousandSeparator(numberWithDecimals);
};
